module.exports = __webpack_public_path__ + "img/yeti_grover_logo.c0fec6eb.png";